import PageNotFound from "./PageNotFound";

const index = () => {
	return <PageNotFound />;
};

export default index;
